import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon, Text } from '@components/base'
import { ScoreArcIndicator, ScoreArcIndicatorProps } from './ScoreArcIndicator'

interface ScoreArcIndicatorWithSeeDetailsButtonProps extends ScoreArcIndicatorProps {
  onPressSeeDetails: () => void
}

export const ScoreArcIndicatorWithSeeDetailsButton = ({
  onPressSeeDetails,
  ...arcIndicatorProps
}: ScoreArcIndicatorWithSeeDetailsButtonProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View>
      <ScoreArcIndicator {...arcIndicatorProps} />
      <TouchableOpacity
        onPress={onPressSeeDetails}
        accessibilityLabel="See Details"
        style={styles.seeDetailsContainer}
      >
        <Text type="regular" bold>
          See Details
        </Text>
        <Icon name="caret-right" weight="bold" size="12" style={styles.icon} />
      </TouchableOpacity>
    </View>
  )
}

const themedStyles = StyleService.create({
  seeDetailsButton: {
    alignSelf: 'center',
    marginTop: 16,
  },
  seeDetailsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    flexDirection: 'row',
  },
  icon: {
    marginLeft: 4,
  },
})
